// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .chartGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  row-gap: 20px;
  height: calc(100vh - 125px);
  overflow-y: auto;
  overflow-x: auto;
  margin: 10px 20px 0 80px;
  margin-top: 50px;
}

.chartGrid::-webkit-scrollbar {
  width: 3px;
}

.chartGrid::-webkit-scrollbar-thumb {
  background-color: gray;
} */
/* .chartGrid::-webkit-scrollbar-track {
  background-color: gray;
} */
/* 
.chartGrid > div {
  margin-bottom: 10px;
}

.chartHeading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(128, 128, 128, 0.1);
  padding: 8px;
}

@media only screen and (max-width: 778px) {
  .chartGrid{
    grid-template-columns: repeat(1, 1fr);
    margin: 4px 2px 0 2px;
    justify-items: center;
    margin-top: 62px;
    overflow-x: hidden;
  }
  .boxdiv{
     position: relative;
     left: 1039px;
     top: -90px;
     display: block; */
/* p: 1;
     m: 1;
     background-color: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
     color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
     border: '4px solid',
     borderColor: (theme) => (theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300'), */
/* border-radius: 2px;
     font-size: 0.875rem;
     font-weight: 700px;
     background-color: rgb(148, 52, 52);

  }
} */
.Xw5HloQcZnGyzaAWOgbk {
  align-items: center;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.juXxzBsOPq3447vxaAd0 {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;
  padding-left: 40px;
  height: calc(100vh - 115px);
  overflow: auto;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 50px;
}

.juXxzBsOPq3447vxaAd0 svg {
  cursor: pointer;
}

/* .cpu{
  margin-top: 0px;
} */
.wZggSTth903nkmvFWZZw {
  /* text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center; */
  position: absolute;
  top: 0px;
  right: 17px;
}

.tgZpSBNcw03d2F5gLJhA {
  text-transform: uppercase;
  font-weight: bold;
  justify-content: center;
  right: 50px;
  top: 0px;
  display: flex;
  padding: 10px;
  background-color: rgb(255, 255, 255);
  color: blue;
  border: 4px solid #dfdfdf;
  border-radius: 2px;
}

.HUNbsCoEYHJTX3uAA7Qg {
  box-shadow: 5;
  height: 250px;
  border: 0;
  border-radius: 0;
  background-color: white;
  width: 450px;
}

@media only screen and (max-width: 1400px) {
  .HUNbsCoEYHJTX3uAA7Qg {
    width: 400px;
    height: 200px;
  }
  .juXxzBsOPq3447vxaAd0 {
    row-gap: 70px;
    margin-left: -20px;
    column-gap: 0px;
  }
  .Xw5HloQcZnGyzaAWOgbk {
    font-size: 14px;
  }
}
@media only screen and (max-width: 1260px) {
  .HUNbsCoEYHJTX3uAA7Qg {
    width: 320px;
    height: 200px;
  }
  .juXxzBsOPq3447vxaAd0 {
    row-gap: 70px;
    margin-left: -20px;
    column-gap: 0px;
  }
  .Xw5HloQcZnGyzaAWOgbk {
    font-size: 14px;
  }
}
@media only screen and (max-width: 1000px) {
  .HUNbsCoEYHJTX3uAA7Qg {
    width: 275px;
    height: 150px;
  }
  .juXxzBsOPq3447vxaAd0 {
    grid-row-gap: 70px;
    row-gap: 115px;
    margin-left: -20px;
    grid-column-gap: 0px;
    column-gap: 0px;
  }
  .Xw5HloQcZnGyzaAWOgbk {
    font-size: 12px;
  }
}
@media only screen and (max-width: 900px) {
  .HUNbsCoEYHJTX3uAA7Qg {
    width: 225px;
    height: 100px;
  }
  .juXxzBsOPq3447vxaAd0 {
    grid-row-gap: 70px;
    row-gap: 150px;
    margin-left: -20px;
    grid-column-gap: 0px;
    column-gap: 0px;
  }
  .Xw5HloQcZnGyzaAWOgbk {
    font-size: 10px;
  }
}
@media only screen and (max-width: 500px) {
  .wZggSTth903nkmvFWZZw {
    margin-top: 15px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;
  }
  .juXxzBsOPq3447vxaAd0 {
    padding-left: 0px;
    padding-top: 0px;
    margin-top: 10px;
    padding-bottom: 100px;
  }
  .HUNbsCoEYHJTX3uAA7Qg {
    width: 225px;
  }
}`, "",{"version":3,"sources":["webpack://./components/Charts/charts.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;GAAA;AAmBA;;GAAA;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;sBAAA;AA0BA;;;;;yFAAA;AAMA;;;;;;GAAA;AAOA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AACF;;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;AAEF;;AAAA;EACE,eAAA;AAGF;;AADA;;GAAA;AAGA;EACE;;;;yBAAA;EAKA,kBAAA;EACA,QAAA;EACA,WAAA;AAIF;;AAFA;EACE,yBAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,aAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAMF;;AAHA;EACE;IACE,YAAA;IACA,aAAA;EAMF;EAJA;IACE,aAAA;IACA,kBAAA;IACA,eAAA;EAMF;EAJA;IACE,eAAA;EAMF;AACF;AAJA;EACE;IACE,YAAA;IACA,aAAA;EAMF;EAJA;IACE,aAAA;IACA,kBAAA;IACA,eAAA;EAMF;EAJA;IACE,eAAA;EAMF;AACF;AAJA;EACE;IACE,YAAA;IACA,aAAA;EAMF;EAJA;IACE,kBAAA;IACA,cAAA;IACA,kBAAA;IACA,oBAAA;IACA,eAAA;EAMF;EAJA;IACE,eAAA;EAMF;AACF;AAJA;EACE;IACE,YAAA;IACA,aAAA;EAMF;EAJA;IACE,kBAAA;IACA,cAAA;IACA,kBAAA;IACA,oBAAA;IACA,eAAA;EAMF;EAJA;IACE,eAAA;EAMF;AACF;AAJA;EACE;IACE,gBAAA;IACA,kBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;EAMF;EAJA;IACE,iBAAA;IACA,gBAAA;IACA,gBAAA;IACA,qBAAA;EAMF;EAJA;IACE,YAAA;EAMF;AACF","sourcesContent":["/* .chartGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  justify-content: space-between;\n  row-gap: 20px;\n  height: calc(100vh - 125px);\n  overflow-y: auto;\n  overflow-x: auto;\n  margin: 10px 20px 0 80px;\n  margin-top: 50px;\n}\n\n.chartGrid::-webkit-scrollbar {\n  width: 3px;\n}\n\n.chartGrid::-webkit-scrollbar-thumb {\n  background-color: gray;\n} */\n/* .chartGrid::-webkit-scrollbar-track {\n  background-color: gray;\n} */\n/* \n.chartGrid > div {\n  margin-bottom: 10px;\n}\n\n.chartHeading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgb(128, 128, 128, 0.1);\n  padding: 8px;\n}\n\n@media only screen and (max-width: 778px) {\n  .chartGrid{\n    grid-template-columns: repeat(1, 1fr);\n    margin: 4px 2px 0 2px;\n    justify-items: center;\n    margin-top: 62px;\n    overflow-x: hidden;\n  }\n  .boxdiv{\n     position: relative;\n     left: 1039px;\n     top: -90px;\n     display: block; */\n/* p: 1;\n     m: 1;\n     background-color: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),\n     color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),\n     border: '4px solid',\n     borderColor: (theme) => (theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300'), */\n/* border-radius: 2px;\n     font-size: 0.875rem;\n     font-weight: 700px;\n     background-color: rgb(148, 52, 52);\n\n  }\n} */\n.chartflexheading {\n  align-items: center;\n  padding: 10px;\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n}\n.chartGrid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-top: 10px;\n  padding-left: 40px;\n  height: calc(100vh - 115px);\n  overflow: auto;\n  justify-content: space-around;\n  align-items: center;\n  padding-bottom: 50px;\n}\n.chartGrid svg {\n  cursor: pointer;\n}\n/* .cpu{\n  margin-top: 0px;\n} */\n.systemuptimediv {\n  /* text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center; */\n  position: absolute;\n  top: 0px;\n  right: 17px;\n}\n.systemuptimespan {\n  text-transform: uppercase;\n  font-weight: bold;\n  justify-content: center;\n  right: 50px;\n  top: 0px;\n  display: flex;\n  padding: 10px;\n  background-color: rgb(255, 255, 255);\n  color: blue;\n  border: 4px solid #dfdfdf;\n  border-radius: 2px;\n}\n.chartdiv {\n  box-shadow: 5;\n  height: 250px;\n  border: 0;\n  border-radius: 0;\n  background-color: white;\n  width: 450px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .chartdiv {\n    width: 400px;\n    height: 200px;\n  }\n  .chartGrid {\n    row-gap: 70px;\n    margin-left: -20px;\n    column-gap: 0px;\n  }\n  .chartflexheading {\n    font-size: 14px;\n  }\n}\n@media only screen and (max-width: 1260px) {\n  .chartdiv {\n    width: 320px;\n    height: 200px;\n  }\n  .chartGrid {\n    row-gap: 70px;\n    margin-left: -20px;\n    column-gap: 0px;\n  }\n  .chartflexheading {\n    font-size: 14px;\n  }\n}\n@media only screen and (max-width: 1000px) {\n  .chartdiv {\n    width: 275px;\n    height: 150px;\n  }\n  .chartGrid {\n    grid-row-gap: 70px;\n    row-gap: 115px;\n    margin-left: -20px;\n    grid-column-gap: 0px;\n    column-gap: 0px;\n  }\n  .chartflexheading {\n    font-size: 12px;\n  }\n}\n@media only screen and (max-width: 900px) {\n  .chartdiv {\n    width: 225px;\n    height: 100px;\n  }\n  .chartGrid {\n    grid-row-gap: 70px;\n    row-gap: 150px;\n    margin-left: -20px;\n    grid-column-gap: 0px;\n    column-gap: 0px;\n  }\n  .chartflexheading {\n    font-size: 10px;\n  }\n}\n@media only screen and (max-width: 500px) {\n  .systemuptimediv {\n    margin-top: 15px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    position: relative;\n  }\n  .chartGrid {\n    padding-left: 0px;\n    padding-top: 0px;\n    margin-top: 10px;\n    padding-bottom: 100px;\n  }\n  .chartdiv {\n    width: 225px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartflexheading": `Xw5HloQcZnGyzaAWOgbk`,
	"chartGrid": `juXxzBsOPq3447vxaAd0`,
	"systemuptimediv": `wZggSTth903nkmvFWZZw`,
	"systemuptimespan": `tgZpSBNcw03d2F5gLJhA`,
	"chartdiv": `HUNbsCoEYHJTX3uAA7Qg`
};
export default ___CSS_LOADER_EXPORT___;
